import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ampmdate'
})
export class AmpmdatePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const hms = value.split(':');
    hms[0] = parseFloat(hms[0]);
    hms[1] = parseFloat(hms[1]);
    hms[2] = parseFloat(hms[2]);

    if (hms[0] === 0) {
      return '12:' + (hms[1] < 10 ? '0' : '') + hms[1] + 'am';
    } else if (hms[0] > 12) {
      return (hms[0] - 12) + ':' + (hms[1] < 10 ? '0' : '') + hms[1] + 'pm';
    } else {
      return hms[0] + ':' + (hms[1] < 10 ? '0' : '') + hms[1] + (hms[0] >= 12 ? 'pm' : 'am');
    }
  }

}
